import { Type, ComponentRef } from '@angular/core';
import { StepType } from '../../../enum/step-type.enum';

export class StepComponent {
  componentRef: ComponentRef<any> = null;
  constructor(
    public component: Type<any>,
    public componentName: string,
    public groupName: string,
    public isActive: boolean,
    public type: StepType = StepType.Buyer,
    public data?: any
  ) {}
}
